module.exports = __webpack_public_path__ + "src/assets/img/$50-million.84680235.svg";